var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"nav nav-pills bordered",class:_vm.navClass},_vm._l((_vm.cats),function(cat,i){return _c('a',{staticClass:"nav-link",class:{active: _vm.selectedCats.includes(i)},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleCat(i)}}},[_vm._v(_vm._s(cat))])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28b90048","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/buttons/ContentTypeSelector.vue
// module id = ojbn
// module chunks = 0